<template>
  <div class="newsletter-form">
    <div class="h3" style="color: white;">{{ $t('landing.newsletter.emailActionDescription') }}</div>
    <el-row>
      <el-col :sm="{ span: 16 }" :xs="{ span: 24 }">
        <el-form :rules="rules" :model="form" ref="subscriptionForm" @validate="onFormValidate" @submit.prevent.native="onSubmit">
          <el-form-item prop="email">
            <el-input v-model="form.email" :placeholder="$t('landing.newsletter.emailPlaceholder')" class="button-large newsletter-form__input" @focus="$ga.event('LandingPage', 'focus_newsletter', 'input')" @change="$ga.event('LandingPage', 'change_newsletter', 'input')">
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :sm="{ span: 8 }" :xs="{ span: 24 }">
        <el-button type="primary" @click="onSubmit" :disabled="!isFormValid" class="button-large newsletter-form__button" v-t="'landing.newsletter.subscribeButton'" v-loading="form.isSending" />
      </el-col>
    </el-row>
    <div class="newsletter-form__privacy text-smaller">{{ $t('landing.newsletter.privacy.text') }} <router-link to="/privacy">{{ $t('landing.newsletter.privacy.link') }}</router-link></div>
    <transition name="fade">
      <el-row v-show="result.title !== null" class="newsletter-form__result-alert">
        <el-alert :title="result.title || ''" :type="result.type" :closable="true" />
      </el-row>
    </transition>
  </div>
</template>

<script>
import { NewsletterAPI } from "@/api";

export default {
  name: "NewsletterInput",
  data() {
    return {
      form: {
        email: "",
        recaptcha: "",
        isValid: false,
        isSending: false
      },
      rules: {
        email: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          },
          {
            type: "email",
            message: " ",
            trigger: ["blur", "change"]
          }
        ]
      },
      result: {
        type: null,
        title: null
      }
    };
  },
  computed: {
    isFormValid() {
      return (
        this.form.isValid &&
        this.form.recaptcha.length > 0 &&
        this.form.email.length > 0
      );
    }
  },
  methods: {
    onSubmit() {
      if (!this.isFormValid) {
        this.$ga.event('LandingPage', 'submit_newsletter_invalid', 'input')
        return
      }

      this.form.isSending = true

      NewsletterAPI.subscribe(this.form)
        .then(res => {
          this.$ga.event('LandingPage', 'submit_newsletter', 'input')
          this.result.type = 'success'
          this.result.title = this.$t('landing.newsletter.subscriptionSuccess')
        })
        .catch(e => {
          this.result.type = 'error'
          this.result.title = this.$t('landing.newsletter.subscriptionError')
          console.error(e)
        })
        .finally(() => {
          this.form.isSending = false
        })
    },
    onFormValidate(el, isValid) {
      this.form.isValid = isValid;
    }
  },
  created() {
    let recaptcha = document.createElement("script");
    recaptcha.setAttribute(
      "src",
      `https://www.google.com/recaptcha/api.js?render=${process.env.RECAPTCHA_KEY}`
    );
    recaptcha.setAttribute("async", "async");
    recaptcha.setAttribute("defer", "defer");
    recaptcha.onload = () => {
      grecaptcha.ready(() => {
        grecaptcha.execute(process.env.RECAPTCHA_KEY).then(token => {
          this.$set(this.form, "recaptcha", token)
        })
      })
    }
    document.head.appendChild(recaptcha);
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/var";
@import "~element-ui/packages/theme-chalk/src/display";

.newsletter-form {
  .newsletter-form__button {
    width: 100%;

    @media screen and (min-width: $--sm) {
      margin-left: -5px;
      position: relative;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .newsletter-form__privacy {
    position: relative;
    @media screen and (min-width: $--sm) {
      top: -20px;
    }

    a {
      text-decoration: underline;
    }
  }

  .newsletter-form__result-alert {
    position: absolute;
    left: 0;
    right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/NewsletterInput.vue